<div class="container">
    <mat-dialog-title class="title-block">
        <h2>CREATE DATA SET</h2>
        <app-close-x-icon (click)="onClose()"></app-close-x-icon>
    </mat-dialog-title>

    <mat-dialog-content class="content-block">

        <mat-form-field class="user-form-field">
            <mat-label>USER</mat-label>
            <mat-select class="user-select" [(ngModel)]="selectedUser" panelClass="import-select">
                <mat-option *ngFor="let user of nonSuperAdminUsers" [value]="user">{{user.first_name}}
                    {{user.last_name}}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="pro-type-form-field">
            <mat-label>PRO TYPE</mat-label>
            <mat-select class="pro-type-select" [(ngModel)]="selectedProType" panelClass="import-select">
                <mat-option *ngFor="let type of proTypes" [value]="type">{{type}}</mat-option>
            </mat-select>
        </mat-form-field>


        <div class="available-data">
            <div class="available-data-top-row">
                <h3 class="header">AVAILABLE DATA</h3>
                <span class="select-all" (click)="selectAllProperties()">Select all</span>
            </div>

            <div class="properties-selection-group">
                <section [ngClass]="{'selected-checkbox' : !property.isRestricted}"
                    *ngFor="let property of newDataSet.properties" class="property-selection">
                    <mat-checkbox [checked]="!property.isRestricted"
                        (change)="setPropertyRestriction(property)">{{property.propertyName}}</mat-checkbox>
                </section>
            </div>
        </div>

    </mat-dialog-content>

    <mat-dialog-actions class="action-block">
        <button class="create-data-set-btn" mat-button (click)="createDataSet()">CREATE DATA SET</button>
        <button class="cancel-btn" mat-button (click)="onClose()">CANCEL</button>
    </mat-dialog-actions>
</div>